<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات مقاله"
        >
          <b-form
            ref="blogform"
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2 form-size"
                md="8"
              >
                <b-row>
                  <b-tabs>

                    <b-tab title="اطلاعات">
                      <b-row class="mt-2">

                        <b-col
                          class="image"
                          cols="12"
                        >
                          <b-media class="mb-2">
                            <template #aside>
                              <b-avatar
                                ref="previewEl"
                                :src="Form.Image"
                                size="90px"
                                rounded
                                button
                                @click="$refs.refInputEl.click()"
                              >
                                <feather-icon
                                  v-if="Form.Image == null"
                                  size="24"
                                  icon="ImageIcon"
                                />
                              </b-avatar>
                            </template>
                            <input
                              :ref="'refInputEl'"
                              type="file"
                              class="d-none"
                              name="Image"
                              @input="imageRenderer($event)"
                            >
                            <b-row>
                              <b-col md="10">
                                <b-form-group
                                  label="عنوان"
                                  label-for="Title"
                                  class="mb-0"
                                >
                                  <b-form-input
                                    id="Title"
                                    v-model="Form.Title"
                                    name="Title"
                                    autocomplete="off"
                                  />
                                </b-form-group>
                              </b-col>
                              <b-col md="2">
                                <b-form-group
                                  label="ترتیب"
                                  label-for="Sort"
                                  class="mb-0"
                                >
                                  <b-form-input
                                    id="Sort"
                                    v-model="Form.Sort"
                                    name="Sort"
                                    autocomplete="off"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-media>
                        </b-col>

                        <b-col md="12">
                          <b-form-group
                            label="پیوند یکتا"
                            label-for="Slug"
                          >
                            <b-form-input
                              id="Sort"
                              v-model="Form.Slug"
                              name="Slug"
                              autocomplete="off"
                              dir="ltr"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="وضعیت"
                            label-for="IsActive"
                          >
                            <v-select
                              v-model="Form.IsActive"
                              :options="enums('IsActive')"
                              dir="rtl"
                              label="text"
                              name="IsActive"
                              :clearable="false"
                              :reduce="x => x.value"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="دسته بندی"
                            label-for="BlogCategoryId"
                          >
                            <z-blog-category
                              v-model="Form.BlogCategoryId"
                              :multiple="false"
                              :clearable="false"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="نویسنده"
                            label-for="Author"
                          >
                            <b-form-input
                              id="Author"
                              v-model="Form.Author"
                              name="Author"
                              autocomplete="off"
                            />
                          </b-form-group>

                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="تاریخ انتشار"
                            label-for="PublishAt"
                          >
                            <date-picker
                              v-model="Form.PublishAt"
                              placeholder=""
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="زمان مطالعه"
                            label-for="ReadingTime"
                          >
                            <b-input-group append="دقیقه">
                              <cleave
                                v-model="Form.ReadingTime"
                                class="form-control"
                                :raw="false"
                                :options="options"
                              />
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12">
                          <b-form-group
                            label="تگ ها"
                            label-for="Tag"
                          >
                            <b-form-tags
                              v-model="Form.Tag"
                              name="Tag"
                              placeholder=""
                              add-button-text="افزودن"
                              add-button-variant="outline-primary"
                            />
                          </b-form-group>
                        </b-col>

                        <z-seo v-model="Form" />

                      </b-row>
                    </b-tab>

                    <b-tab title="محتوا">
                      <b-row class="mt-2">
                        <b-col md="12">
                          <b-form-group
                            label="توضیحات"
                            label-for="Description"
                          >
                            <z-quill-editor v-model="Form.Description" />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-tab>

                    <b-tab title="سوالات متداول">
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <b-row
                            v-for="(item, index) in Form.BlogFaq"
                            :key="index"
                          >

                            <b-col md="10">
                              <b-form-group
                                label="سوال"
                              >
                                <b-form-input
                                  v-model="item.Title"
                                  autocomplete="off"
                                />
                              </b-form-group>
                            </b-col>

                            <b-col
                              md="2"
                              class="mb-1"
                              style="display: flex; align-items: flex-end;"
                            >
                              <template v-if="blogFaqRemoveId !== index">
                                <b-button
                                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                  variant="outline-danger"
                                  class="btn-icon rounded-circle"
                                  @click="removeBlogFaq(index)"
                                >
                                  <feather-icon
                                    icon="TrashIcon"
                                  />
                                </b-button>
                              </template>
                              <template v-else>
                                <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  class="btn-icon rounded-circle"
                                  variant="outline-primary"
                                  @click="cancelBlogFaq"
                                >
                                  <feather-icon icon="XIcon" />
                                </b-button>
                                <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  class="btn-icon rounded-circle ml-1"
                                  variant="outline-primary"
                                  @click="confirmBlogFaq"
                                >
                                  <feather-icon icon="CheckIcon" />
                                </b-button>
                              </template>
                            </b-col>

                            <b-col cols="12">
                              <b-form-group
                                label="پاسخ"
                                label-for="Description"
                              >
                                <div class="form-label-group">
                                  <b-form-textarea
                                    id="Description"
                                    v-model="item.Description"
                                    autocomplete="off"
                                    rows="3"
                                    no-resize
                                  />
                                </div>
                              </b-form-group>
                            </b-col>

                            <b-col cols="12">
                              <hr>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col>
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="gradient-info"
                            @click="addBlogFaq"
                          >
                            <feather-icon
                              icon="PlusIcon"
                              class="mr-25"
                            />
                            <span>افزودن</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-tab>

                  </b-tabs>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col
                    cols="12"
                    class="mt-1 mb-2 text-center"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>

        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZBlogCategory from '@/tools/blogcategory.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'BlogDetails',
  components: {
    ZSeo,
    ZQuillEditor,
    ZBlogCategory,
  },
  data() {
    return {
      Form: {
        Id: 0,
        Title: null,
        MetaTitle: null,
        Description: null,
        Image: null,
        IsActive: true,
        BlogFaq: [],
        BlogCategoryId: null,
        Tag: [],
        ImageAlt: null,
        Slug: null,
        Sort: 0,
        ReadingTime: null,
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      loading: false,
      blogFaqRemoveId: null,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.blog.add
      if (this.$route.params.id) {
        url = this.$api.blog.update
      }

      const formData = new FormData(this.$refs.blogform)

      formData.append('Id', this.Form.Id)
      formData.append('IsActive', this.Form.IsActive)

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      if (this.Form.BlogCategoryId) {
        formData.append('BlogCategoryId', this.Form.BlogCategoryId)
      }

      if (this.Form.ReadingTime) {
        formData.append('ReadingTime', this.Form.ReadingTime.replaceAll(',', ''))
      }

      this.Form.BlogFaq.forEach((item, index) => {
        formData.append(`BlogFaq[${index}].Title`, item.Title)
        formData.append(`BlogFaq[${index}].Description`, item.Description)
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.blog.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.Schemas = this.Form.Schemas
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    addBlogFaq() {
      this.Form.BlogFaq.push({ Title: null, Description: null })
    },
    removeBlogFaq(index) {
      this.blogFaqRemoveId = index
    },
    confirmBlogFaq() {
      this.Form.BlogFaq.splice(this.blogFaqRemoveId, 1)
      this.blogFaqRemoveId = null
    },
    cancelBlogFaq() {
      this.blogFaqRemoveId = null
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
